function n(e) {
  return +e;
}
export {
  n as default
};
